import polylabel from 'polylabel';
import { ICoordinates } from 'react-give-me-map';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import { BLANK_STYLE } from 'static/config/stylesConfig';

export const useBackgroundImageMarker = () => {
    function getBackgroundMarker(
        defaultStyles: string[],
        imageUrl: string,
        coordinates: ICoordinates[]
    ) {
        if (defaultStyles[0] !== BLANK_STYLE || !imageUrl || !coordinates) {
            return null;
        }
        const [centerLat, centerLng] = polylabel([coordinates.map(({ lat, lng }) => [lat, lng])]);
        const marker: IImageV2WorldMarker = {
            id: 'background',
            visible: true,
            selectable: false,
            lat: centerLat,
            lng: centerLng,
            elementType: 'v2/image' as const,
            order: 0,
            isExternalPoint: false,
            elementData: {
                imageUrl,
                coordinates,
                generatedBackgroundColor: null,
                generatedImageUrl: null,
                generatedEmoji: null,
                generatedIconColor: null,
                generatedIconUrl: null,
                nonRotatedCoordinates: coordinates,
                rotation: 0,
                opacity: 1,
                flipHorizontal: false,
                flipVertical: false
            }
        };

        return marker;
    }

    return {
        getBackgroundMarker
    };
};
